export default __webpack_public_path__ + "static/media/Dark Amulet of Severed Souls.78a1efe3.jpg";